import axios from '../../helpers/axios';
import {
  GetSalesLookupNeighborhoodsParams,
  IBuildRes,
  IBuildStatus,
  IDropdownResponse,
  IElevationDropdownResponse,
  IPlanDropdownResponse,
  ISalesEmailTemplateLookup
} from '../../models';
import { logError } from '../../services';

const base = `/api/sales/lookup`;
export const getSalesCladdingVersions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/cladding-versions`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesCladdingVersions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupClientSources = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/client-sources`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupClientSources failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupClientStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/client-statuses`);

    return data;
  } catch (error: any) {
    logError(error, 'getAdminLookupClientStatuses failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupNeighborhoods = async (params: GetSalesLookupNeighborhoodsParams): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/neighborhoods`, { params });

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupNeighborhoods failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupOvenLayouts = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/oven-layouts`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupOvenLayouts failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupPlans = async (apiParams: any): Promise<IPlanDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/plans`, { params: apiParams });

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupPlans failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupStates = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/states`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupStates failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupTerritories = async (params: any): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/territories`, { params });

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupTerritories failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupAvailableElevations = async (
  planId: number | string
): Promise<IElevationDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/${planId}/elevations/available`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupAvailableElevations failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupElevations = async (
  planId: number | string,
  forMarketingMaterials?: boolean,
  neighborhoodSeriesId?: number
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/${planId}/elevations`, {
      params: { neighborhoodSeriesId, forMarketingMaterials }
    });

    return data;
  } catch (error: any) {
    logError(error, 'getSalesLookupElevations failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesNeighborhoodAvailableLots = async (
  NeighborhoodId: number | string,
  ExcludeTakenBuilds: boolean
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(
      `${base}/neighborhoods/${NeighborhoodId}/availablelots?ExcludeTakenBuilds=${ExcludeTakenBuilds}`
    );

    return data;
  } catch (error: any) {
    logError(error, 'getSalesNeighborhoodAvailableLots failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getDocumentTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/document-types`);

    return data;
  } catch (error: any) {
    logError(error, 'getDocumentTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getFinancingTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/financing-types`);

    return data;
  } catch (error: any) {
    logError(error, 'getFinancingTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getLenders = async (neighborhoodId: number | string): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/lenders/${neighborhoodId}`);

    return data;
  } catch (error: any) {
    logError(error, 'getLenders failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getNeighborhoodSeries = async (
  neighborhoodId: number | string
): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/neighborhood-series/${neighborhoodId}`);

    return data;
  } catch (error: any) {
    logError(error, 'getNeighborhoodSeries failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getGarageOptions = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/garage-options`);

    return data;
  } catch (error: any) {
    logError(error, 'getGarageOptions failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getContractAcceptanceStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/contract-acceptance-statuses`);

    return data;
  } catch (error: any) {
    logError(error, 'getContractAcceptanceStatuses failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getIncentiveTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/incentive-types`);

    return data;
  } catch (error: any) {
    logError(error, 'getIncentiveTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getUnderContractBuildStatuses = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/under-contract-statuses`);

    return data;
  } catch (error: any) {
    logError(error, 'getUnderContractBuildStatuses failed');
    return Promise.reject(error?.response?.data);
  }
};

// This function is used in src/pages/sales/ten-day-builds/ten-day-builds-list.tsx
export const getSalesBuilds = async (filters?: {
  neighborhoodId?: number | string;
  lotNumber?: number | string;
  phase?: string;
  isActive?: boolean;
  isSpec?: boolean;
  personId?: number | string;
  agentId?: number | string;
  status?: string;
  planId?: number | string;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
  planElevationId?: number | string;
  isForPlanFinder?: boolean;
}): Promise<IBuildRes> => {
  try {
    const { data } = await axios.get(`${base}/builds`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getSalesBuilds failed');
    return Promise.reject(error);
  }
};

// This function is used in src/pages/sales/reports/plan-finder-filters.tsx
export const getSalesBuildStatuses = async (): Promise<IBuildStatus[]> => {
  try {
    const { data } = await axios.get(`${base}/build-statuses`);
    return data;
  } catch (error) {
    logError(
      {
        error
      },
      'getSalesBuildStatuses failed'
    );
    return Promise.reject(error);
  }
};

export const getAddressBookNotificationTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`${base}/address-book-notification-types`);

    return data;
  } catch (error: any) {
    logError(error, 'getAddressBookNotificationTypes failed');
    return Promise.reject(error?.response?.data);
  }
};

export const getSalesLookupEmailTemplates = async (): Promise<ISalesEmailTemplateLookup[]> => {
  try {
    const { data } = await axios.get(`${base}/email-templates`);

    return data;
  } catch (error: any) {
    logError(error, 'getSalesEmailTemaplates failed');
    return Promise.reject(error?.response?.data);
  }
};
